import {createRoot} from 'react-dom/client';
import {NewsletterSignup} from './NewsletterSignup';

const subscribeMessage = "Get America's trendiest parties delivered right to your inbox!";
const container = document.getElementById('newsletter-signup-root');
// TODO this root doesn't exist anywhere, but this file is referenced in webpack & in a bundle on some base pages
// remove when we can do so safely

if (container) {
  const root = createRoot(container);
  root.render(
    <NewsletterSignup
      isSmallButton={!window.is_mobile_site}
      subscribeButtonMessage="Sign up"
      subscribeMessage={subscribeMessage}
    />
  );
}
